<div class="Dialog" mat-dialog-content>
  <div>
    <p>Custom rings are final sale and cannot be refunded.</p>
  </div>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">I Agree</button>
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial>Decline</button>
  </mat-dialog-actions>
</div>